// @flow
import { createSelector } from 'reselect';
import type { State, CarEntity, SessionConfig, DebugConfig } from '../types';
import { getActivityIndex } from '../utils/targetUtils';
import { sessionConfigSelector, debugConfigSelector } from './configSelectors';
import { vehiclesSubStateSelector } from './targetSelectors';
import { carEntitiesSelector, getDataSource } from './carSelectors';


export const vehicleListSelector = (state: State) => {
    const subState = vehiclesSubStateSelector(state);
    return subState.list;
};

export const vehicleEntitiesSelector = (state: State) => {
    const subState = vehiclesSubStateSelector(state);
    return subState.entities;
};

export const makeVehicleEntitySelector = (icao: string) => (state: State) => {
    const entities = vehicleEntitiesSelector(state);
    return entities && entities[icao];
};

export const vehicleCountSelector = (state: State) => {
    const subState = vehiclesSubStateSelector(state);
    return subState.list.length;
};

export const sortedVehicleListSelector = createSelector<State, any, $ReadOnlyArray<string>, $ReadOnlyArray<string>, $ReadOnlyArray<CarEntity>, SessionConfig, DebugConfig>([
    vehicleListSelector,
    carEntitiesSelector,
    sessionConfigSelector,
    debugConfigSelector
], (vehicles, entities, sessionConfig, debugConfig) => {
    const entityMap = vehicles.map((icao => {
        const entity = entities[icao];

        let car;
        if(entity) {
            const dataSource = getDataSource(entity, sessionConfig, debugConfig);
            const buffer = entity[dataSource];
            car = buffer && buffer[0];
        }


        return {
            icao,
            activityIndex: getActivityIndex(car && car.TimeOfTrackInformation, sessionConfig)
        };
    }));

    entityMap.sort((a, b) => {
        if(a.activityIndex > b.activityIndex) {
            return -1;
        }
        else if(a.activityIndex < b.activityIndex) {
            return 1;
        }
        else {
            return 0;
        }
    });

    return entityMap.map(map => map.icao);
});

export const vehicleUserIdSelector = (icao: string) => (state: State) => {
    const entity = makeVehicleEntitySelector(icao)(state);
    return entity && entity.user;
};